import * as React from 'react';
import { COMMUNITY_ROLES } from '@/constants/community-roles';
import { USER_ROLES } from '@/constants/user-roles';
import { Layout as DashboardLayout } from '@/layouts/v2/layout';
import type { RouteObject } from 'react-router-dom';
import { Outlet } from 'react-router-dom';

import { paths } from '@/paths';
import MeetingPage from '@/pages/meeting';
import MeetingsPage from '@/pages/meetings';
import { RoleGuard } from '@/components/auth/guards/role-guard';
import { ACCOUNT_ROLES } from '@/constants/account-roles';

export const route: RouteObject = {
  path: '/meetings',
  element: (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  ),
  children: [
    {
      index: true,
      element: (
        <RoleGuard
          displayUnauthorized
          requiredAccountRoles={[
            ACCOUNT_ROLES.ACCOUNT_OWNER,
            ACCOUNT_ROLES.ACCOUNT_ADMIN,
            ACCOUNT_ROLES.ACCOUNT_MANAGER,
          ]}
          requiredCommunityRoles={[COMMUNITY_ROLES.COMMUNITY_MANAGER]}
        >
          <MeetingsPage />
        </RoleGuard>
      ),
    },
    {
      path: paths.meetings.meeting,
      element: (
        <RoleGuard
          displayUnauthorized
          requiredAccountRoles={[
            ACCOUNT_ROLES.ACCOUNT_OWNER,
            ACCOUNT_ROLES.ACCOUNT_ADMIN,
            ACCOUNT_ROLES.ACCOUNT_MANAGER,
          ]}
          requiredCommunityRoles={[COMMUNITY_ROLES.COMMUNITY_MANAGER]}
        >
          <MeetingPage />
        </RoleGuard>
      ),
    },
  ],
};
